import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=82a0abb0&scoped=true"
import script from "./ImageSlider.ts?vue&type=script&lang=ts&external"
export * from "./ImageSlider.ts?vue&type=script&lang=ts&external"
import style0 from "./ImageSlider.scss?vue&type=style&index=0&id=82a0abb0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a0abb0",
  null
  
)

export default component.exports